import { render, staticRenderFns } from "./ConfirmAssignmentEducators.vue?vue&type=template&id=64ef1357&"
import script from "./ConfirmAssignmentEducators.vue?vue&type=script&lang=js&"
export * from "./ConfirmAssignmentEducators.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports